<template>
	<div class="order" v-title data-title="订单模块">
		<leftnav class="fl" itemcode="B-DDTP"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<form id="form1" action="" method="post" class="whitebox pb-5">
					<div class=" banpage  order_page">
						<div class="order_block order_model">
							<h3 class="bluetitle fl">模块选择</h3>
							<div class="right_table ">
								<div class="titlebox">
									<h5 class="title text-left pl-5 ml-5">模块</h5>
									<h5 class="title mr-4">价格</h5>
									<a class="title pl dib">详情</a>
								</div>
								<ul class="order_table">
									<li class="order_m_tr" :class="{ 'current': modulelist_code.indexOf(list.code) > -1 }"
										v-for="(list, index) in modulelist" :key="index" v-if="list.price != 0">
										<input type="checkbox" name="categoryList" :value="list"
											:disabled="list.price == 0" v-model="modulelist_active" class="checkbox fl"
											@change="moduleClick(list)" />
										<span class="fl model_name text-left ml-4 pl-5">{{index+1 +'.'+'&nbsp;' +list.title }}</span>
										<span class="model_price fl" data="38000">￥{{ list.price }}</span>
										<span @click="routerblank(list.url)" class="fl detailbtn">详情</span>
									</li>
									<li class="order_m_tr" :class="{ 'current': Zmodule,'allChek':true}"
										v-for="(list, index) in allModule" :key="'Z' + index">
										<input type="checkbox" name="categoryList" :value="list" v-model="Zmodule"
											class="checkbox fl" @change="moduleClick(list, 'all')" />
										<span class="fl model_name text-left ml-4 pl-5 red-font">全库7个模块优惠价</span>
										<span class="model_price fl red-font">￥{{ list.price }}</span>
										<span class="fl detailbtn" @click="routerblank(list.url)">详情</span>
									</li>
									<li class="order_m_tr" :class="{ 'current': modulelist_code.indexOf(list.code) > -1 }"
										v-for="(list, index) in modulelist" :key="index" v-if="list.price == 0">
										<input type="checkbox" name="categoryList" :value="list"
											:disabled="list.price == 0" v-model="modulelist_active" class="checkbox fl"
											@change="moduleClick(list)" />
										<span class="fl model_name text-left ml-4 pl-5">{{ list.title }}</span>
										<span class="model_price fl" data="38000">购全库，自动送</span>
										<span @click="routerblank(list.url)" class="fl detailbtn">-</span>
									</li>
								</ul>
								
							</div>

						</div>
						<div class="order_block order_year">
							<h3 class="bluetitle fl">时间选择</h3>
							<input type="hidden" name="year" id="year" class="order_year_input" value="3" />
							<ul class="right_table">
								<li class="fl" :class="{ 'current': form.year == 1 }" @click="yearClick(1)"><i
										class="checkbox " data="1"></i><span>一年</span></li>
								<li class="fl" :class="{ 'current': form.year == 2 }" @click="yearClick(2)"><i
										class="checkbox " data="2"></i><span>两年</span></li>
								<li class="fl" :class="{ 'current': form.year == 3 }" @click="yearClick(3)"><i
										class="checkbox " data="3"></i><span>三年</span></li>
							</ul>
						</div>
						<div class="order_block order_price">
							<h3 class="bluetitle fl">价格</h3>
							<div class="right_table">
								<div class="titlebox recommend">
									<h5 class="title">模块</h5>
									<h5 class="title">一年价</h5>
									<h5 class="title">两年价</h5>
									<h5 class="title ">三年价</h5>
								</div>
								<ul class="order_table">
									<li v-show="!Zmodule">
										<span class="fl">{{ modulelist_active.length }}个模块</span>
										<span class="fl" :class="{ 'current': form.year == 1 && !Zmodule }"> ¥
											{{ getTotalPrice()*1 }}</span>
										<span class="fl" :class="{ 'current': form.year == 2 && !Zmodule }"> ¥
											{{ getTotalPrice()*2 }} </span>
										<span class="fl" :class="{ 'current': form.year == 3 && !Zmodule }"> ¥
											{{ getTotalPrice()*3 }}</span>
									</li>
									<!-- <li>
										<span class="fl">2个模块</span>
										<span class="fl" :class="{'current':form.year==1 && modulelist_active.length == 2}"> ¥ {{oneYearPrice}}</span>
										<span class="fl" :class="{'current':form.year==2 && modulelist_active.length == 2}"> ¥ {{twoYearPrice}}</span>
										<span class="fl" :class="{'current':form.year==3 && modulelist_active.length == 2}"> ¥ {{treeYearPrice}}</span>
									</li>
									<li>
										<span class="fl">3个模块</span>
										<span class="fl" :class="{'current':form.year==1 && modulelist_active.length == 3}"> ¥ {{oneYearPrice}}</span>
										<span class="fl" :class="{'current':form.year==2 && modulelist_active.length == 3}"> ¥ {{twoYearPrice}}</span>
										<span class="fl" :class="{'current':form.year==3 && modulelist_active.length == 3}"> ¥ {{treeYearPrice}}</span>
									</li> -->
									<li>
										<span class="fl">全库7个模块</span>
										<span class="fl" :class="{ 'current': Zmodule && form.year == 1 }"><em class="red-font">¥ 9800</em> <em v-show="(getTotalPrice()*1)-9800 > 0"> ( 购全库<i class="red-font">省￥{{ (getTotalPrice()*1)-9800 }}</i> ) </em></span>
										<span class="fl" :class="{ 'current': Zmodule && form.year == 2 }"><em class="red-font">¥ 16800</em><em v-show="(getTotalPrice()*2)-16800 > 0"> ( 购全库<i class="red-font">省￥{{ (getTotalPrice()*2)-16800}}</i> ) </em></span>
										<span class="fl" :class="{ 'current': Zmodule && form.year == 3 }"><em class="red-font">¥ 19800</em><em v-show="(getTotalPrice()*3)-19800 > 0"> ( 购全库<i class="red-font">省￥{{ (getTotalPrice()*3)-19800}}</i> ) </em></span>
									</li>
								</ul>
								<p class="order_tips" v-show="(getTotalPrice()*1)-9800 > 0"><em class="redfont font-20 font-bold">* </em>特别提示:你购买分模块的汇总价格,已经超过直接购买全库的价格,建议您选择全库购买。
								</p>
								<p class="order_tips red-font" v-show="(getTotalPrice()*1)-9800 < 0 || (getTotalPrice()*1)-9800 == 0 "><em class="redfont font-20 font-bold">*
								</em>购买全库套餐，更具性价比！</p>
							</div>
						</div>
						<div class="order_block order_contact">
							<h3 class="bluetitle mb-3">联系人信息<span>（ <em class="redfont font-20 font-bold">*</em>为必填内容）</span></h3>
							<div class="order_contact_table">
								<div class="inputlist_b fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>姓名</label>
									<input type="text" name="name" v-model="form.name" class="order_input mandatory"
										value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>手机号</label>
									<input type="text" name="phone" v-model="form.mobile" class="order_input mandatory"
										value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">性别</label>
									<div class="right_input">
										<span class="fl"><input type="radio" v-model="form.gender" name="gender"
												class="order_input gender1" value="男" />男</span>
										<span class="fl"><input type="radio" v-model="form.gender" name="gender"
												class="gender2 order_input" value="女" />女</span>
									</div>
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">固定电话</label>
									<input type="text" name="telphone" v-model="form.phone" class="order_input"
										value="" />
								</div>
								<div class="inputlist_a fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>单位名称</label>
									<input type="text" name="companyName" v-model="form.companyName"
										class="order_input mandatory" value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">职务</label>
									<input type="text" name="position" v-model="form.position" class="order_input"
										value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">邮编</label>
									<input type="text" name="postcode" v-model="form.postcode" class="order_input"
										value="" />
								</div>
								<div class="inputlist_c fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>地址</label>
									<input type="text" name="address" v-model="form.address"
										class="order_input mandatory" value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">Email</label>
									<input type="text" name="email" v-model="form.email" class="order_input" value="" />
								</div>
								<div class="inputlist_d fl">
									<label for="" class="labename">备注</label>
									<textarea name="remark" v-model="form.remark" class="order_input"></textarea>
								</div>
							</div>
						</div>
						<div class="order_total order_block">
							<h3 class="bluetitle fl">合计</h3>
							<div class="order_t_list">
								<div class="fl">
									<h5 class="title">总费用</h5>
									<p v-show="!Zmodule"><strong class="orader_model_price">{{getTotalPrice() * form.year}} </strong><em>元</em></p>
									<p v-show="Zmodule && form.year == 1"><strong class="orader_model_price">¥ 9800 </strong><em>元</em></p>
									<p v-show="Zmodule && form.year == 2"><strong class="orader_model_price">¥ 16800 </strong><em>元</em></p>
									<p v-show="Zmodule && form.year == 3"><strong class="orader_model_price">¥ 19800 </strong><em>元</em></p>
								</div>
								<div class="fl">
									<h5 class="title">所选模块</h5>
									<p class="active-module font-20" v-show="!Zmodule"><span class="color-0069D3">{{website}} - </span><strong class="order_model_name" >{{ modulelist_text.join('、')}} </strong></p>
									<p class="active-module font-20" v-show="Zmodule"><span class="color-0069D3">{{website}} - </span><strong class="order_model_name" >全库 </strong></p>
								</div>
								<div class="fl">
									<h5 class="title">使用年限</h5>
									<p><strong class="orader_model_year">{{ form.year }}</strong> <em>年</em></p>
								</div>
							</div>
						</div>
						<div class="submitBtn order_submit" @click="submitOrder">提交订单</div>
					</div>
				</form>

			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'chainEnterprise',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse']),

		// oneYearPrice: function () {
		// 	let total = 0;
		// 	total = this.getTotalPrice();
		// 	return total * 1;
		// },
		// twoYearPrice: function () {
		// 	let total = 0;
		// 	total = this.getTotalPrice();
		// 	return total * 2;
		// },
		// treeYearPrice: function () {
		// 	let total = 0;
		// 	total = this.getTotalPrice();
		// 	return total * 3;
		// },
	},
	data() {
		return {
			website:'产业研究大脑',
			modulelist: [],
			modulelist_active: [],
			modulelist_code: [],
			modulelist_text: [],
			allModule: [],
			Zmodule: true,
			form: {
				module: [],
				year: 3,
				name: '',
				gender: '',
				mobile: '',
				phone: '',
				companyName: '',
				position: '',
				postcode: '',
				address: '',
				email: '',
				remark: '',
			},
		}
	},
	beforeCreate() {

	},
	created() {
		this.getModule();

	},

	mounted() {
	},
	methods: {
		// 表单验证
		validate(){
			if (this.form.name == ''|| this.form.mobile == ''|| this.form.companyName == ''||this.form.address == '') {
				this.$message.error('*星号为必填项，请完善信息！');
				if(this.form.name == ''){
					document.getElementsByClassName('mandatory')[0].classList.add('error');
				}else if(this.form.mobile == ''){
					document.getElementsByClassName('mandatory')[1].classList.add('error');
				}else if(this.form.companyName == ''){
					document.getElementsByClassName('mandatory')[2].classList.add('error');
				}else if(this.form.address == ''){
					document.getElementsByClassName('mandatory')[3].classList.add('error');
				}
				let elements = document.getElementsByClassName('error')[0];
				console.log(elements.classList);
				elements.scrollIntoView({
					block: 'center', // 值有start,center,end，nearest，当前显示在视图区域中间
					behavior: 'smooth', // 值有auto、instant,smooth，缓动动画（当前是慢速的）
				});
				return false;
			}else if(this.modulelist_code.length < 1 && !this.Zmodule){
				this.$message.error('请选择模块！');
				return false;
			}else{
				return true;
			}
		},
		submitOrder() {
			let falg = this.validate();
			if(falg){
				let ajaxurl = this.$api.free.order.post();
				let tempCode=[];
				if(this.Zmodule){
					this.form.module = 'Z';
					this.form.price = this.form.year*9800;
				}else{
					this.form.module = this.modulelist_code.join(',');
					this.form.price =  this.getTotalPrice() * this.form.year;
				}
				console.log(this.form);
				var _this = this;
				$.ajax({
					type:"POST",
					url:ajaxurl,
					data:_this.form,
					success:function(res){ 
						console.log(res); 
						if(res.success){
						_this.$message.success('提交成功！');
						_this.routerself('/paytype?id='+ res.data.id);
						// _this.$router.push({
						// 	name: 'paytype',
						// 	params:res.data,
						// });
					}else{
						_this.$message.error(res.msg);
					}
					}
				});	 
			}
			
				
		},
		// ckeckForm() {
			
		// },
		//年份点击
		yearClick(year) {
			this.form.year = year;

		},
		//模块点击
		moduleClick(list, type) {
			// console.log(list, this.modulelist_active,this.modulelist_code);
			console.log('模块点击', this.modulelist_active.length);
			// if(this.modulelist_active.length < 1){
			// 	return;
			// }
			if (type == 'all') {
				console.log('全选', this.Zmodule);
				this.Zmodule = true;
				this.modulelist_active = [];
			} else {
				// this.modulelist_active.push(list);
				//四个模块选中全库
				// if (this.modulelist_active.length > 3) {
				// 	// this.Zmodule = true;
				// } else {
					this.Zmodule = false;
					//将选中的code 和 文本分离出来方便调接口传参以及页面展示
					
				// }
			}
			this.modulelist_code = this.modulelist_active.map(item=>item.code);
			this.modulelist_text = this.modulelist_active.map(item=>item.title);
		},
		//计算总价
		getTotalPrice() {
			var total = 0; 
			this.modulelist_active.forEach(item=>{
				total += item.price;
			})
			// console.log('总价',total);
			return total;
		},

		//获取模块列表
		getModule() {
			var _this = this;
			var ajaxurl = this.$api.free.order.module();
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					console.log('模块列表', res);
					let data = res.data.data;
					data.url='/researchIndex';
					_this.modulelist = res.data.list;
					_this.allModule.push(data);
					_this.moduleClick(_this.allModule,'all');
					_this.modulelist.forEach(item=>{
						if(item.title == '产业研究'){
							item.url='/report?type=10005';
						}else if(item.title == '产业链研究'){
							item.url='/allchain?type=10561';
						}else if(item.title == '重点企业研究'){
							item.url='/enterpriseList?type=9&Pt=1';
						}else if(item.title == '城市竞争力研究'){
							item.url='/regional-competitiveness';
						}else if(item.title == '本地投资趋势'){
							item.url='/localInvestAnalysis?type=1';
						}else if(item.title == '产业动态跟踪'){
							item.url='/investment-clues3';
						}else if(item.title == '产业排行榜'){
							item.url='/investment-clues7';
						}else if(item.title == '关系计算器'){
							item.url='/enterprisesCityRelation';
						}else if(item.title == '工作台'){
							item.url='/workbench';
						}else if(item.title == '个人中心'){
							item.url='/baseInformation';
						}
					})
					// _this.modulelist.push(res.data.data);		
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

	}
}
</script>

<style lang="scss" scoped>
@import url('../../css/order.css');

.whitebg {
	background-color: #fff;
	padding-bottom: 100px;
}

.order_page {
	min-width: 1336px;
	width: 90%;
	margin: 0 auto;
	max-width: 1498px;
}

.active-module {
	width: 400px;
	line-height: 32px;
}
.detailbtn{
	cursor: pointer;
	&:hover{
		color: #0071ce;
	}
}
</style>
